
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 .667a8.333 8.333 0 100 16.666A8.333 8.333 0 009 .667zm0 15A6.667 6.667 0 119 2.333a6.667 6.667 0 010 13.334z","fill":"#16A75C"}}),_c('path',{attrs:{"d":"M9 6.5a.833.833 0 100-1.667A.833.833 0 009 6.5zM9 7.333a.833.833 0 00-.834.834v4.166a.833.833 0 001.667 0V8.167A.833.833 0 009 7.333z","fill":"#16A75C"}})])
          )
        }
      }
    